import { z } from 'zod';

export const RequestApprovalAccessSchema = z.object({
  email: z.string().email(),
});

export type RequestApprovalAccessForm = z.infer<
  typeof RequestApprovalAccessSchema
>;
